import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c21f8a56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row no-wrap lead-info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " • ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_highlighted_text = _resolveComponent("highlighted-text")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_radio = _resolveComponent("q-radio")!

  return (_openBlock(), _createBlock(_component_q_radio, _mergeProps({
    val: _ctx.lead.dobjId
  }, _ctx.RADIO_PROPS, {
    class: "iuf-radio no-radio",
    modelValue: _ctx.model,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model) = $event)),
    onClick: _ctx.goToLeadOverview
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_icon, { name: _ctx.icon }, null, 8, ["name"]),
        _createVNode(_component_highlighted_text, {
          label: _ctx.lead.name,
          "text-filter": _ctx.searchInput
        }, null, 8, ["label", "text-filter"]),
        (_ctx.lead?.codeName)
          ? (_openBlock(), _createBlock(_component_highlighted_text, {
              key: 0,
              class: "code-name",
              label: `(${_ctx.lead.codeName})`,
              "text-filter": _ctx.searchInput
            }, null, 8, ["label", "text-filter"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", {
          class: "text-link",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToCompanyOverview && _ctx.goToCompanyOverview(...args)), ["prevent","stop"]))
        }, [
          _createVNode(_component_q_icon, {
            name: _ctx.ICONS_NAME.COMPANY_OUTLINE
          }, null, 8, ["name"]),
          _createVNode(_component_highlighted_text, {
            label: _ctx.company.name,
            "text-filter": _ctx.searchInput
          }, null, 8, ["label", "text-filter"])
        ]),
        _hoisted_2,
        _createElementVNode("span", {
          class: "text-link",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToBriefOverview && _ctx.goToBriefOverview(...args)), ["prevent","stop"]))
        }, [
          _createVNode(_component_q_avatar, {
            color: _ctx.getColorName(_ctx.brief.style),
            class: "text-uppercase",
            "text-color": "white"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.brief.name.charAt(0)), 1)
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(_component_highlighted_text, {
            label: _ctx.brief.name,
            "text-filter": _ctx.searchInput
          }, null, 8, ["label", "text-filter"])
        ])
      ])
    ]),
    _: 1
  }, 16, ["val", "modelValue", "onClick"]))
}